import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../common/Button";
import warning from "../../../assets/agent/warning.svg";

function FinishModal({ open, onClose  }) {
  const navigate = useNavigate();
  const modalRef = useRef(null);
  const { t } = useTranslation();

  const handleFinish = async () => {
    navigate(`/agent/achievement`);
  };

  const handleBackdropClick = (e) => {
    if (modalRef.current && e.target === modalRef.current) {
      onClose();
    }
  };

  if (!open) return null;

  return (
    <>
      <div
        ref={modalRef}
        onClick={handleBackdropClick}
        className="fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-30 px-4"
        style={{zIndex: 1000}}
      >
        <div className="bg-white rounded-2xl text-primary text-xl shadow-xl w-full max-w-[660px] p-7 flex flex-col items-center space-y-6">
          <img src={warning} alt="warning" className="w-[60px] h-[60px]" />
          <p className="mb-1 text-xl font-bold">{t("agent.nextCall.finishModal")}</p>
          <div className="relative flex items-center">
            <span className="absolute left-0 w-1 h-1 bg-[#0A1E4C] rounded-full -ml-1"></span>
            <hr className="flex-1 border-t-2 border-[#0A1E4C] w-[350px]" />
            <span className="absolute right-0 w-1 h-1 bg-[#0A1E4C] rounded-full -mr-1"></span>
          </div>
          <p className="my-4 text-xl w-[370px] text-center">
            {t("agent.nextCall.desc")}?
          </p>

          <div className="flex gap-14 flex-wrap justify-center">
            <Button variant="secondary" className="w-full sm:w-48 px-4 py-2"
              onClick={() => {
                onClose();
              }}
            >
              {t("agent.nextCall.keep")}
            </Button>
            <Button
                  variant="primary"
                  className="w-full sm:w-48 px-4 py-2"
                  onClick={() => {
                    onClose();
                    handleFinish()
                  }}
                >
                  {t("agent.noteInfo.yes")}, {t("continue")}
                </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default FinishModal;
